import { Flex, Text } from "@chakra-ui/react";
import { useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function Registros(props: any) {
  const colors = useRecoilState(customColors)[0];

  return (
    <Flex w={"100%"} flexDirection={"column"} mt={4}>
      <Text fontSize={"14px"} fontWeight={"700"} color={colors.BLUEMONEDDBUTTONS}>
        {props.title}
      </Text>
      <Text fontSize={"14px"}>{props.value}</Text>
    </Flex>
  );
}
